<template>
  <div id="func-18">
    <FuncionalidadeHeader :titulo="tituloNavegacao"/>
    <div v-if="publicacoes.length" class="list-publicacoes">
      <el-collapse
        :value="collapseds"
        class="list-manuais-revistas"
      >
        <el-collapse-item
          v-for="(publicacao, index) in publicacoes"
          :key="index"
          :name="publicacao.titulo"
        >
          <template slot="title">
            <div class="collapse-title">
              <h1>{{ publicacao.titulo }} ({{ publicacao.manuais_revistas.length }})</h1>
            </div>
          </template>

          <el-row style="display: flex; flex-wrap: wrap;">
            <el-col class="arquivo" v-for="(arquivo, index) in publicacao.manuais_revistas" :key="index">
              <div @click="download(arquivo)">
                <div class="arquivo-sombra"></div>
                <img class="arquivo-capa" :src="arquivo.capa_url"/>
                <p class="arquivo-titulo">{{ arquivo.descricao }}</p>
                <p class="arquivo-detalhes">{{ dataFormat(arquivo.data_inicial) }} PDF {{ arquivo.arquivo_tamanho }}Mb</p>
              </div>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-if="!publicacoes.length">
      <ErrorVazio :showBtn="false"/>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ErrorVazio from '@/components/Error/ErrorVazio'
import moment from 'moment'
import { forceDownloadBase64 } from '@/utils/Download'
import { LogResource } from '../../API'

export default {
  name: 'Func18RevistasManuais',
  components: {
    FuncionalidadeHeader,
    ErrorVazio
  },
  data () {
    return {
      publicacoes: [],
      actives: [],
      estiloTab: ''
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    collapseds () {
      return [...Array(this.publicacoes.length).keys()]
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    estiloFundo () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getRevistasManuais()
      await this.activeNames()

      this.estiloTab = `<style> .el-collapse-item__header {
          background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d !important;
        }
       .el-collapse-item__arrow {
       color: ${this.estilo.aplicacao.corPrimariaAplicacao} !important;
       } </style>`
    },
    async getRevistasManuais () {
      const result = await this.apiFuncionalidade.lista({
        loading: true,
        handlerErrorIgnore: [404]
      })

      if (result) {
        this.publicacoes = result.data
      } else {
        this.publicacoes = []
      }
    },
    activeNames () {
      this.publicacoes.forEach(p => {
        this.actives.push(p.titulo)
      })
    },
    dataFormat (data) {
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YY')
    },
    async download (arquivo) {
      LogResource.registroAcesso(this.funcionalidade.idFuncionalidade, arquivo.id_area_manuais)
      await forceDownloadBase64({
        nome: `${arquivo.descricao}.pdf`,
        url: arquivo.arquivo_url
      })
    }
  }
}
</script>
